/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function identity(x) {
    return x;
}
//# sourceMappingURL=identity.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/identity.js
// module id = 31
// module chunks = 1